import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {EMPTY} from 'rxjs';
import {catchError, delay, takeUntil, tap} from 'rxjs/operators';

import {Destroyable} from '../destroyable.component';
import {WorkflowV2Service} from '../shared/workflow/workflow-v2.service';

@Component({
  selector: 'gp-process-reply-email',
  templateUrl: './process-reply-email.component.html',
  styleUrls: ['./process-reply-email.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProcessReplyEmailComponent extends Destroyable implements OnInit {
  public isProgress: boolean = true;
  public isSuccess: boolean = false;
  public isError: boolean = false;

  public inProgressMessage: string = 'REPLY.EMAIL.task_validation_in_progress';
  public successApproveMessage: string = 'REPLY.EMAIL.task_approve_success';
  public successDeclineMessage: string = 'REPLY.EMAIL.task_decline_success';
  public errorMessage: string = 'REPLY.EMAIL.task_validation_error';
  public backToDashboardMessage: string = 'REPLY.EMAIL.back_to_dashboard';

  private outcome: string = '';
  private taskId: string = '';

  constructor(private route: ActivatedRoute, private workflowService: WorkflowV2Service, private translate: TranslateService) {
    super();
  }

  public ngOnInit(): void {
    this.taskId = this.route.snapshot.paramMap.get('taskId');
    this.outcome = this.route.snapshot.queryParams['outcome'];
    this.getTaskCompletionStatus(this.taskId, this.outcome);
  }

  public getTaskCompletionStatus(taskId: string, outcome: string) {
    this.workflowService.getTaskCompletionStatus(taskId, outcome).pipe(
      delay(4000),
      tap(() => {
        this.showSuccessMessage();
      }),
      catchError(errorResponse => {
        this.showErrorMessage();
        return EMPTY;
      }),
      takeUntil(this.componentDestroyed$)
    ).subscribe();
  }

  public getSuccessMessage() {
    return this.outcome === 'approve' ? this.successApproveMessage : this.successDeclineMessage;
  }

  private showSuccessMessage() {
    this.isProgress = false;
    this.isSuccess = true;
  }

  private showErrorMessage() {
    this.isProgress = false;
    this.isError = true;
  }
}
